import { apiClient } from "../config";

async function getSpecieProfile(specieId: string) {
  const res = await apiClient.get(`/admin/species/${specieId}`);
  return res.data;
}

export default getSpecieProfile;
